import {AnimationBaseController, GameApiBase} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {SoundConstants} from "../../Constants/SoundConstants";
import {Key, SoundType} from "@denishussar/html5-game-engine";
import {LocalizationContents} from "../../LocalizationContents";


export interface IButtonControllerOptions
{
    onClick:() => void;
    hotKey: string;
    localKey?: string;
    label?: string
}

export class ButtonController extends AnimationBaseController {
    $model: GameModel;
    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;

    public selected = false;

    public constructor(@Inject private _options:IButtonControllerOptions,
                       @Inject private _arenaApi: GameApiBase) {
        super("ButtonController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        let keyboard = null;

        if(this._options.hotKey){
            keyboard = {
                [Key[this._options.hotKey]]:{
                    pressed: () => {
                        if(!this._enabled){
                            return;
                        }
                        this._pressed = true;
                        this.gotoAndStop("down");
                    },
                    released: () => {
                        if(!this._enabled || !this._pressed){
                            return;
                        }
                        this._pressed = false;
                        this.gotoAndStop("up");
                        this._options.onClick();
                    },
                    down: () => {
                    },
                }
            }
        }

        return <IAnimationControllerConfiguration>{
            childControllers: {
            },
            onPointerDown: () =>{
                if(!this._enabled){
                    return;
                }
                this._pointerDown = true;
                this.gotoAndStop("down");
            },
            onPointerOut: () =>{
                if(!this._enabled){
                    return;
                }
                if (!this._pointerDown) {
                    this.gotoAndStop(this.selected ? "down" : "up");
                }
                this._pointerOver = false;
            },
            onPointerOver: () =>{
                if(!this._enabled){
                    return;
                }
                if (this._pointerDown) {
                    this.gotoAndStop("down");
                }
                else {
                    this.gotoAndStop(this.selected ? "down" : "over");
                }
                this._pointerOver = true;
            },
            onPointerUp: () =>{
                if(!this._enabled){
                    return;
                }
                this._pointerDown = false;
                if (this._pointerOver) {
                    this.gotoAndStop(this.selected ? "down" : "over");
                }
                else {
                    this.gotoAndStop(this.selected ? "down" : "up");
                }
                this.soundManager.play(SoundConstants.BUTTON_CLICK);
            },
            onPointerUpOutside: () =>{
                if(!this._enabled){
                    return;
                }
                this.gotoAndStop(this.selected ? "down" : "up");
                this._pointerDown = false;
            },
            onTap: () =>{
                const enabled = this._enabled
                if (!enabled) {
                    this.soundManager.play(SoundConstants.BUTTON_DISABLED);
                    return;
                }
                this._options.onClick();
                if (enabled) {
                    this.soundManager.play(SoundConstants.BUTTON_CLICK);
                }
            },
            sounds: [
                {
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.BUTTON_DISABLED,
                    type: SoundType.SFX
                }
            ],
            keyboard: keyboard
        };
    }

    public toggle(select:boolean){
        this.selected = select;
        this.gotoAndStop(this.selected ? "down" : "up");
    }

    public disabled(){
        this._enabled = false;
        this._pressed = false;
        this._pointerDown = false;
    }

    public enabled(){
        this._enabled = true;
        this.gotoAndStop("up");
    }

    protected onInitialize(): void {
        if(this._options.localKey){
            this.setTextByQuery("labelText", LocalizationContents.getText(this._options.localKey).toLocaleUpperCase());
        }

        if(this._options.label){
            this.setTextByQuery("labelText", this._options.label);
        }

        this.setTextVerticalAlignByQuery("labelText", "middle");
        this.setTextStyleByQuery("labelText", {
            dropShadow: true,
            dropShadowColor: 0,
            dropShadowAngle: 0,
            dropShadowDistance: 2,
            dropShadowBlur: 1
        });
    }

}

